import { Avatar, Dropdown } from '../Components/ui';
import type { DropdownItem } from '../Components/ui/Dropdown';
import { LogOut, User as UserIcon, Settings, Building2 } from 'lucide-react';
import { useAuthHeader, useSignOut } from 'react-auth-kit';
import { useNavigate } from 'react-router-dom';
import User from '../Models/User';
import { performLogout } from '../Functions/session';

/**
 * Menu utilisateur du topbar : carte de profil + actions (profil, paramètres, déconnexion).
 */
const UserMenu = (props: { user: User & { Image?: string } }) => {
    const { user } = props;
    const signOut = useSignOut();
    const authHeader = useAuthHeader();
    const navigate = useNavigate();

    const logOut = () => {
        performLogout(signOut, authHeader());
    };

    const items: DropdownItem[] = [
        {
            key: 'profile-card',
            disabled: true,
            label: (
                <div className="flex items-center gap-3 py-2 min-w-[240px]">
                    <Avatar size={44} src={user.Image} name={user?.Name} className="flex-shrink-0" />
                    <div className="min-w-0">
                        <div className="font-bold text-[var(--eb-text)] whitespace-nowrap overflow-hidden text-ellipsis">
                            {user?.Name}
                        </div>
                        <div className="text-xs text-[var(--eb-text-muted)]">{user?.CodeU} · {user?.Group}</div>
                    </div>
                </div>
            ),
        },
        {
            key: 'filiale',
            disabled: true,
            label: (
                <div className="flex items-center gap-2 text-[12.5px] text-[var(--eb-text-muted)]">
                    <Building2 size={16} />
                    <span>Filiale : <b className="text-[var(--eb-text)]">{user?.CodeFiliale}</b> · Service : <b className="text-[var(--eb-text)]">{user?.CodeS}</b></span>
                </div>
            ),
        },
        { key: 'divider-1', divider: true },
        {
            key: 'profil',
            icon: <UserIcon size={18} />,
            label: 'Mon profil',
        },
        {
            key: 'settings',
            icon: <Settings size={18} />,
            label: 'Paramètres',
            onClick: () => navigate('/setting'),
        },
        { key: 'divider-2', divider: true },
        {
            key: 'logout',
            danger: true,
            icon: <LogOut size={18} />,
            label: 'Déconnexion',
            onClick: logOut,
        },
    ];

    return (
        <Dropdown items={items} placement="bottomRight">
            <div className="eb-topbar-user">
                <Avatar src={user.Image} name={user?.Name} />
                <span className="name">{user?.Name?.split(' ')[0]}</span>
            </div>
        </Dropdown>
    );
};

export default UserMenu;
